import React from 'react';
import bgImage from '../../../assets/servicebanner/Forex.webp';

const Breadcrumb = () => {
  return (
    <div className='hero'>
      <img
        src={bgImage}
        alt='breadcrumb background'
        className='hero-img'
      />
      <ul className='breadcumb'>
        <li>Home</li>
        <li>Forex</li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
